// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__LqtwD","title":"ClientInsurance_title__3DxfJ","itemText":"ClientInsurance_itemText__3_xhh"};